import { useState, useRef } from "react";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  idJurados,
  juradoEditar,
  menuJuradoAction,
} from "../redux/actions/juradosAction";
import { RootState } from "../redux/reducers";
// models
import {
  RegistrarJuradoModel,
  initialValuesRegistrarJuradoModel,
} from "../models/RegistrarJurado/registrarjurado.model";
// api services
import apiJurados from "../api/Jurados/api-jurados";
// dates
import moment from "moment";
// route
import { useNavigate, useParams } from "react-router";
// styled componens

import DocumentosService from "../api/Documentos/api-documentos";
import { openNotification } from "../utils/Notifactions";
import { consolidateIdentificate } from "../utils/dataSelectOptions";
import GetStorageUser from "../middlewares/GetStorageUser";
import apiParticipantes from "../api/Participantes/api-participantes";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";

export const useRegistrarjurado = () => {
  const { registrarJurado, estadoFormulario } = useParams();

  const [visibleFields, setVisibleFields] = useState(false);
  const [visibleFieldsPais, setVisibleFieldsPais] = useState(false);
  const [disabledInput, setDisabledInput] = useState(true);
  const [loading, setLoading] = useState(false);
  const { decrypt } = useEncrypt();

  // redux
  const dispatch = useDispatch();
  const { menuJurado } = useSelector(
    (state: RootState) => state.jurado
  );
  const idJurado = localStorage.getItem("idJurado");
  //  state
  const [jurado, setJurado] = useState<RegistrarJuradoModel>(
    initialValuesRegistrarJuradoModel
  );
  const [imageselected, setImageselected] = useState<any>();
  const [editarJurado, setEditarJurado] = useState<boolean>(false);

  // ref
  const fileInputRef = useRef<any>();
  const fileImageRef = useRef<any>();
  // route
  const navigate = useNavigate();
  // functions

  const prevScreen = () => {
    if (menuJurado) {
      dispatch(menuJuradoAction(false));
      return navigate("/usuario/MenuJurado");
    }
    return "/usuario/";
  };

  const cargarDatosJurado = async (id_jurado: number) => {
    try {
      const user = GetStorageUser()
      const datosJurado = await apiJurados.obetenerJuradoDocumento(user.documento);

      if (datosJurado.departamento_residencia !== null) {
        setVisibleFieldsPais(true);
      } else {
        setVisibleFieldsPais(false);
      }

      if (datosJurado.municipio_residencia !== null) {
        if (datosJurado.municipio_residencia === "MEDELLÍN") {
          setVisibleFields(true);
          setDisabledInput(false);
        } else {
          setVisibleFields(false);
          setDisabledInput(true);
        }
      } else {
        setVisibleFields(false);
      }

      datosJurado.fecha_nacimiento = datosJurado.fecha_nacimiento
        ? moment(datosJurado.fecha_nacimiento).format("YYYY-MM-DD")
        : "";

      if (datosJurado.path_foto !== null) {
        let data: any = await DocumentosService.consultarArchivo(
          datosJurado.path_foto
        );

        if (data !== undefined) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setImageselected(URL.createObjectURL(data.data));
          };
          reader.readAsDataURL(data.data);
        } 
      }

      let array: any = {
        perfil: datosJurado.perfil,
        tipo_identificacion: datosJurado.tipo_identificacion,
        numero_documento: datosJurado.numero_documento,
        fecha_nacimiento: datosJurado.fecha_nacimiento,
        primer_nombre: datosJurado.primer_nombre,
        segundo_nombre: datosJurado.segundo_nombre,
        primer_apellido: datosJurado.primer_apellido,
        segundo_apellido: datosJurado.segundo_apellido,
        genero: datosJurado.genero,
        orientacion_sexual: datosJurado.orientacion_sexual,
        identidad_genero: datosJurado.identidad_genero,
        path_documento: datosJurado.path_documento,
        etnia: datosJurado.etnia,
        telefono_celular: datosJurado.telefono_celular,
        telefono_fijo: datosJurado.telefono_fijo,
        pais_nacimiento: datosJurado.pais_nacimiento,
        departamento_residencia: datosJurado.departamento_residencia,
        municipio_residencia: datosJurado.municipio_residencia,
        comuna_residencia: datosJurado.comuna_residencia,
        barrio: datosJurado.barrio,
        direccion: datosJurado.direccion,
        estrato: datosJurado.estrato,
        correo_electronico: datosJurado.correo_electronico,
      };
      return setJurado(array);
    } catch (error) {
      console.log(error);
    }
  };

  const getUser = async () => {
    try {
      const user = GetStorageUser()
      let typeDocConsolidate = consolidateIdentificate.filter((x) => x.value === user.tipo_identificacion);
      let tipoDoc = typeDocConsolidate.length > 0 ? typeDocConsolidate[0].target : 'CC';

      const jurado = await apiJurados.obetenerJuradoDocumento(user.documento);

      if (jurado) {
        localStorage.setItem("idJurado", jurado.id_jurado);
        cargarDatosJurado(jurado.id_jurado);
        return setEditarJurado(true);
      }

      setJurado({
        ...initialValuesRegistrarJuradoModel,
        tipo_identificacion: tipoDoc,
        numero_documento: user.documento,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const guardarFoto = async (e: any) => {
    if (e.target.files.length > 0) {
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        let archivo = e.target.files[0];
        if (archivo.size > 5000000) {
          return openNotification({
            titulo: "Error",
            descripcion: "Solo se permiten archivos menores a 5MB",
            placement: "bottomRight",
          });
        }
        const reader = new FileReader();
        reader.readAsDataURL(archivo);
        reader.onloadend = () => {
          //
          setImageselected(URL.createObjectURL(archivo));
        };
        const formData = new FormData();
        formData.append("archivo", archivo);
        const data = await DocumentosService.guardarArchivo(formData);
        return setJurado({ ...jurado, path_foto: data.data });
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos png / jpg",
          placement: "bottomRight",
        });
      }
    }
  };
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type === "application/pdf") {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setJurado({ ...jurado, path_documento: data.data });
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
    }
  };

  const guardarFormulario = async () => {
    const id_convocatoria = decrypt(localStorage.getItem('idConvocatoriaPostulacion'));
    const validacionPostulacionJurado = await apiParticipantes.validarPostulacion(id_convocatoria, Number(jurado.numero_documento));

    if (validacionPostulacionJurado.data !== null) {
      ObjNotificaciones.MSG_ERROR('warning', '¡Ya inscribiste tu hoja de vida!', 'Por favor, revisa tus postulaciones desde la sección "Jurado - Mis Postulaciones" o postúlate a una nueva convocatoria');
      return navigate('/usuario');
    }

    if (
      parseInt(moment(jurado.fecha_nacimiento).format("YYYYMMDD")) >
      parseInt(moment().format("YYYYMMDD"))
    ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha nacimiento seleccionada es mayor a la actual",
        placement: "bottomRight",
      });
    }

    let data;
    setLoading(true);
    if (estadoFormulario !== "" && estadoFormulario !== undefined) {
      await apiJurados.ActualizarInformarcionJurado(idJurado, jurado);
      dispatch(juradoEditar(false));
      setLoading(false);
      return navigate("/usuario/estadosFormulario");
    }

    if (editarJurado) {
      if (jurado.pais_nacimiento !== "Colombia") {
        jurado.departamento_residencia = "";
        jurado.municipio_residencia = "";
        jurado.comuna_residencia = "";
        jurado.barrio = "";
      }

      if (jurado.municipio_residencia !== "MEDELLÍN") {
        jurado.comuna_residencia = "";
        jurado.barrio = "";
      }
      await apiJurados.ActualizarInformarcionJurado(idJurado, jurado);
      setLoading(false);
      return navigate("/usuario/categorias");
    }

    if (menuJurado) {
      await apiJurados.ActualizarInformarcionJurado(idJurado, jurado);
      dispatch(menuJuradoAction(false));
      setLoading(false);
      return navigate("/usuario/MenuJurado");
    }

    if (registrarJurado) {
      await apiJurados.guardarInformarcionjurados(jurado);
      setLoading(false);
      navigate("/login");
      return;
    }

    data = await apiJurados.guardarInformarcionjurados(jurado);
    localStorage.setItem("idJurado", data.data.id_jurado.toString());

    if (!data.ok) {
      return openNotification({
        titulo: "Error",
        descripcion: data.message,
        placement: "bottomRight",
      });
    }

    dispatch(idJurados(parseInt(data.data.id_jurado)));
    setLoading(false);
    return navigate("/usuario/categorias");
  };

  const guardarInformacion = async () => {
    await apiJurados.guardarInformarcionjurados(jurado);
  };
  return {
    jurado,
    setJurado,
    fileInputRef,
    fileImageRef,
    guardarFoto,
    guardarArchivo,
    imageselected,
    guardarFormulario,
    guardarInformacion,
    cargarDatosJurado,
    prevScreen,
    visibleFields,
    visibleFieldsPais,
    setVisibleFields,
    setVisibleFieldsPais,
    disabledInput,
    setDisabledInput,
    getUser,
    loading,
  };
};
